import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { passwordSchema } from '@shared/schemas';
import { authUtils } from '@/hooks/useAuth';

export function ResetPasswordPage() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);

    if (password !== confirmPassword) {
      setError('Die Passworter stimmen nicht überein.');
      return;
    }

    const validation = passwordSchema.safeParse(password);
    if (!validation.success) {
      setError(validation.error.errors[0].message);
      return;
    }

    try {
      await authUtils.updatePassword(password);
      setSuccess(true);
    } catch {
      setError('Passwort-Update fehlgeschlagen. Bitte versuchen Sie es erneut.');
    }
  }

  if (success) {
    return (
      <div className="max-w-md mx-auto py-12">
        <h1 className="text-2xl font-serif mb-4">Passwort geandert</h1>
        <p className="text-text-secondary mb-4">Ihr Passwort wurde erfolgreich geandert.</p>
        <button onClick={() => navigate('/anmelden')} className="btn-primary">Zur Anmeldung</button>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto py-12">
      <h1 className="text-2xl font-serif mb-6">Neues Passwort setzen</h1>

      {error && (
        <div className="mb-4 p-3 bg-status-danger/10 border border-status-danger/20 text-status-danger text-sm rounded-sm">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="password" className="block text-sm font-medium mb-1">Neues Passwort</label>
          <input id="password" type="password" className="input-field" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        <div>
          <label htmlFor="confirmPassword" className="block text-sm font-medium mb-1">Passwort bestatigen</label>
          <input id="confirmPassword" type="password" className="input-field" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
        </div>
        <button type="submit" className="btn-primary">Passwort andern</button>
      </form>
    </div>
  );
}
